import { useNuxtApp } from '#app'

// 与 App 端保持一致，favorites 服务会依赖该字段做来源识别
const appType = 'react-mall-app'

export function favoritesCheck(data) {
  return useNuxtApp().$customFetch('../collectionSite/mall/frontserver/favorites/check', {
    method: 'POST',
    body: { ...(data || {}), appType: (data && data.appType) || appType },
  })
}

export function favoritesAdd(data) {
  return useNuxtApp().$customFetch('../collectionSite/mall/frontserver/favorites/add', {
    method: 'POST',
    body: { ...(data || {}), appType: (data && data.appType) || appType },
  })
}

export function favoritesRemove(data) {
  return useNuxtApp().$customFetch('../collectionSite/mall/frontserver/favorites/remove', {
    method: 'POST',
    body: { ...(data || {}), appType: (data && data.appType) || appType },
  })
}

